import { Link } from "react-router-dom";
import { Instagram, Twitter, Facebook } from "lucide-react";
import { Logo } from "@/components/Logo";

export function Footer() {
  return (
    <footer className="bg-black border-t border-zinc-900 mt-auto">
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-flex mb-4">
              <Logo size="h-8" />
            </Link>
            <p className="text-sm text-zinc-500 max-w-xs leading-relaxed">
              More Than a Workout. A Stronger You. Find your accountability partner and stay consistent.
            </p>
            <div className="flex gap-3 mt-5">
              {[Instagram, Twitter, Facebook].map((Icon, i) => (
                <span key={i} className="grid place-items-center w-9 h-9 rounded-full border border-zinc-800 text-zinc-400 hover:text-white hover:border-[#E53E3E] transition-colors cursor-pointer">
                  <Icon className="w-4 h-4" />
                </span>
              ))}
            </div>
          </div>

          <FooterCol title="Platform" links={[
            { label: "How It Works", to: "/how-it-works" },
            { label: "Sports", to: "/sports" },
            { label: "Find Facilities", to: "/facilities" },
          ]} />
          <FooterCol title="Join" links={[
            { label: "For Members", to: "/for-members" },
            { label: "For Partners", to: "/for-partners" },
            { label: "Get Started", to: "/get-started" },
          ]} />
          <FooterCol title="Company" links={[
            { label: "About", to: "/about" },
            { label: "Contact / Support", to: "/support" },
            { label: "Login", to: "/login" },
          ]} />
        </div>
        <div className="mt-12 pt-6 border-t border-zinc-900 flex flex-col sm:flex-row justify-between gap-2 text-xs text-zinc-600">
          <p>© {new Date().getFullYear()} FitLynk. All rights reserved.</p>
          <p>People. Sports. Progress.</p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="text-xs font-bold uppercase tracking-widest text-zinc-500 mb-4">{title}</h4>
      <ul className="space-y-3">
        {links.map((l) => (
          <li key={l.to}>
            <Link to={l.to} className="text-sm text-zinc-400 hover:text-[#E53E3E] transition-colors">{l.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
